// extracted by mini-css-extract-plugin
module.exports = {"terms-conditions":"terms_terms-conditions__NiqHX"};